import bearing from "@turf/bearing";
import { Feature, LineString } from "geojson";

import { MAP_CLICK_BUFFER } from "fond/constants";
import { BBox } from "fond/types/geometry";
import { FilterConfiguration, SublayerConfig } from "fond/types/ProjectLayerConfig";

// For FilterConfigurations that have not set a filter we show all features
// This blank filter will match all features
const BLANK_FILTER = ["!", false];

/**
 * Builds a Mapbox filter based on the negative of other sublayer FilterConfigurations
 * @returns FilterConfiguration
 */
export const negativeFilterConfiguration = (sublayers: SublayerConfig[]): FilterConfiguration["Mapbox"] => {
  return ["!", ["any", ...sublayers.map(({ FilterConfiguration: filter }) => filter?.Mapbox || BLANK_FILTER)]];
};

export const openStreetViewUrl = (feature: Feature<LineString>) => {
  const from = feature.geometry.coordinates[0];
  const to = feature.geometry.coordinates[1];
  const direction = bearing([from[0], from[1]], [to[0], to[1]]);
  const myUrl = `https://maps.google.com/maps?q=&layer=c&cbll=${from[1]},${from[0]}&cbp=11,${direction},0,0,0`;

  window.open(myUrl, "_blank")?.focus();
};

/**
 * Builds a bounding box around a click event to be used for querying features near the click location
 */
export const clickEventBBox = (event: mapboxgl.MapMouseEvent, buffer = MAP_CLICK_BUFFER): BBox => {
  return [
    [event.point.x - buffer, event.point.y - buffer],
    [event.point.x + buffer, event.point.y + buffer],
  ];
};
